import _ from 'underscore';
import Promise from 'bluebird';

import { uncheckedInjectionContext as globalContext } from '@bingads-webui-campaign/injection-context';
import * as putil from '@bingads-webui-universal/primitive-utilities';

const { showSummaryDetailsPopup } = globalContext.require('campaignui/feature/scheduled-import/view/shared-column-configs/import-summary-col');
const jsdataCampaign = globalContext.require('component/js-data-campaign/index');

const importSchemaExtensionForFilter = {
  ImportName: {
    filterable: true,
  },
  EntityIdsSpecified: {
    chooseType: 'radio-boolean',
    filterable: true,
    operators: ['eq'],
  },
};

function findImportTaskItem(id) {
  return jsdataCampaign.TaskItem.find(id, {
    cacheResponse: false,
  });
}

export function updateEntitySchemaForImport(originalSchema, copy = true) {
  const schema = (copy ? putil.cloneDeep : _.identity)(originalSchema);
  const lastImportInfo = putil.get(schema, 'properties.LastImportInfo');
  const lastImportInfoProperties = putil.get(lastImportInfo, 'schema.properties');

  if (lastImportInfoProperties) {
    _.each(lastImportInfoProperties, (prop, propName) => {
      _.extend(prop, importSchemaExtensionForFilter[propName]);
    });
  }
  return schema;
}

export function getImportStatusFilterOptions(originalOptions) {
  const importGridFilterableFields = _.union(['Name', 'AccountInactiveReasons'], _.keys(importSchemaExtensionForFilter));

  // eslint-disable-next-line no-param-reassign
  originalOptions.fields = _.filter(originalOptions.fields, field => _.contains(importGridFilterableFields, field.name));
  return originalOptions;
}

export function removeImportStatusFilterOptions(originalFields) {
  return _.reject(originalFields, field => _.contains(_.keys(importSchemaExtensionForFilter), field.name));
}

export function showImportSummaryDetailsPopup(e, account, i18n) {
  // file import-summary-col is already loaded to render import summary column, so no need to make it lazy load.
  showSummaryDetailsPopup(e, account.LastImportInfo, i18n, findImportTaskItem);
}

export function loadShowScheduledImportPopup() {
  return new Promise((resolve) => {
    const deps = [
      '@bingads-webui/i18n-amd-loader!campaignui/feature/accounts-summary',
      'component/i18n/loader!legacy/global',
      '$/schema!campaign/ImportTaskItem',
      'campaignui/feature/bingadsgrid/template/status-column',
      'campaignui/feature/scheduled-import/template/import-schedule-name',
      'campaignui/feature/scheduled-import/view/import-schedule-constants',
      'campaignui/feature/scheduled-import/view/shared-column-configs/import-freq-col',
      'component/edm-campaign/index',
      'component/js-data-campaign/index',
    ];
    window.require(deps, () => {
      import(/* webpackMode: 'eager' */ './show-scheduled-import-popup')
        .then(resolve);
    });
  });
}
